module.exports = __webpack_public_path__ + "img/royalFlush.d8a261e6.png";